import { render, staticRenderFns } from "./TvaDropdown.vue?vue&type=template&id=5df692c0&scoped=true&"
import script from "./TvaDropdown.vue?vue&type=script&lang=js&"
export * from "./TvaDropdown.vue?vue&type=script&lang=js&"
import style0 from "./TvaDropdown.vue?vue&type=style&index=0&id=5df692c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df692c0",
  null
  
)

export default component.exports